import type en from './en';

const es: typeof en = {
  chatMeeting: {
    prompt: '{{name}} ha propuesto quedar. ¿Quedamos?',
    yes: 'Sí, ofrece horarios',
    decline: 'Rechazar',
    notInterested: 'No me interesa',
    error: 'No se ha podido guardar. Inténtalo de nuevo.',
  },
  join: {
    title: 'Tienes acceso a una Secretaria de IA',
    titleThanks: '(gracias a {{name}})',
    scanQr:
      'Escanea el código QR con tu teléfono para iniciar una conversación de WhatsApp con tu nueva secretaria.',
    fromThere:
      'A partir de ahí podrás configurar tu cuenta y dejar que tu secretaria se encargue de tus gestiones.',
    openWhatsApp: 'Abrir WhatsApp',
    inviteOnlyTitle: 'Por ahora, Dream es solo por invitación.',
    invalidBody:
      'Este enlace de invitación no es válido: puede que esté mal escrito o que ya no esté activo. Pide un enlace nuevo a la persona que te invitó, o apúntate a nuestra lista de espera y te avisaremos.',
    joinWaitlist: 'Unirme a la lista de espera',
    loading: 'Cargando',
  },
  connect: {
    statusAlreadyConnected:
      'Esta cuenta ya está conectada. Puedes añadir otra cuenta abajo.',
    statusExpired: 'Este enlace ha caducado. Pide uno nuevo a tu secretaria.',
    statusInvalidToken:
      'Este enlace no es válido. Pide uno nuevo a tu secretaria.',
    statusAlreadyLinkedOther:
      'Esa cuenta ya está vinculada a otra cuenta de Dream.',
    statusError:
      'No hemos podido cargar tu página de conexión. Inténtalo de nuevo.',
    missingToken:
      'Falta el token de onboarding. Abre esta página desde WhatsApp.',
    loadAccountsError:
      'No se pueden cargar las cuentas conectadas en este momento.',
    disconnectError: 'No se puede desconectar esta cuenta.',
    yourAccount: 'Tu cuenta',
    title: 'Conecta tu cuenta',
    body1:
      'Conecta tu correo y tu calendario para que tu secretaria pueda estar al tanto de tus tareas y vigilar choques y conflictos de agenda.',
    body2: 'Nunca enviará un correo desde tu cuenta.',
    allDone: '¿Todo listo?',
    youCan: 'Puedes',
    returnToWhatsApp: 'volver a WhatsApp',
    keepConnecting: ' o seguir conectando cuentas',
    loadingAccounts: 'Cargando tus cuentas conectadas…',
    connectedAccount: 'Cuenta conectada',
    disconnectAria: 'Desconectar {{account}}',
    thisAccount: 'esta cuenta',
    connectGoogle: 'Conectar tu cuenta de Google',
    connectAnotherGoogle: 'Conectar otra cuenta de Google',
    connectOutlook: 'Conectar tu cuenta de Outlook',
    connectAnotherOutlook: 'Conectar otra cuenta de Outlook',
    disclaimer: 'Compatible con cuentas de Gmail, Google Workspace y Outlook.',
  },
  travelOptions: {
    title: 'Opciones de viaje',
    eyebrow: 'Tu viaje',
    tabs: 'Opciones de viaje',
    flights: 'Vuelos',
    hotels: 'Alojamientos',
    trains: 'Trenes',
    flight: 'Vuelo',
    hotel: 'Alojamiento',
    train: 'Tren',
    removeTask: 'Eliminar tarea',
    book: 'Reservar',
    bookWithDream: 'Reservar con Dream',
    separateTickets: 'Billetes separados',
    separateTicketsWarning:
      'Estos vuelos se reservan por separado. Comprueba el tiempo de conexión y ten en cuenta posibles retrasos.',
    seeReturnTimes: 'Ver horarios de vuelta',
    otherReturnTimes: 'Otros horarios de vuelta ({{count}})',
    bookBothFlights: 'Reservar ambos vuelos',
    viewStay: 'Ver alojamiento',
    loading: 'Cargando opciones de viaje…',
    close: 'Cerrar',
    outbound: 'Ida',
    return: 'Vuelta',
    returnsErrorTitle: 'No pudimos cargar tus vuelos de vuelta',
    returnsErrorBody: 'Inténtalo de nuevo o vuelve para ver otras opciones',
    returnsRateLimited:
      'Demasiadas solicitudes en esta página. Espera unos minutos.',
    tryAgain: 'Intentar de nuevo',
    back: 'Atrás',
    returnRefreshCountdown: 'Los precios se actualizarán en {{time}}',
    flightUnavailable: 'Este vuelo ya no está disponible. Elige otro.',
    gettingLivePricesButton: 'Obteniendo precios actualizados…',
    flightBookingPending:
      'Estoy reservando {{time}} a {{place}}. Te avisaré cuando esté listo.',
    flightBookingConfirmed:
      'He reservado {{time}} a {{place}} el {{date}}.{{reference}}',
    flightBookingUnknown:
      'Estoy comprobando si {{time}} a {{place}} se ha reservado. Te avisaré.',
    flightBookingNotBooked:
      'No pude reservar {{time}} a {{place}}. Te escribiré para decirte qué hacer a continuación.',
    hotelBookingPending:
      'Estoy reservando {{name}}. Te avisaré cuando esté listo.',
    hotelBookingConfirmed: 'He reservado {{name}}.{{reference}}',
    hotelBookingUnknown:
      'Estoy comprobando si {{name}} se ha reservado. Te avisaré.',
    hotelBookingNotBooked:
      'No pude reservar {{name}}. Te escribiré para decirte qué hacer a continuación.',
    sameTicket: 'Mismo billete',
    confirmBooking: 'Confirmar reserva',
    traveller: 'Viajero',
    sort: {
      label: 'Ordenar por',
      recommended: 'Recomendado',
      price: 'Precio',
      departure: 'Hora de salida',
      arrival: 'Hora de llegada',
      duration: 'Duración',
      rating: 'Valoración',
    },
  },
  suggestions: {
    loading: 'Cargando…',
    linkExpiredTitle: 'Enlace caducado',
    somethingOffTitle: 'Algo no va bien',
    expiredBody:
      'Este enlace ha caducado. Pídeselo a tu secretaria en WhatsApp y te enviará uno nuevo.',
    invalidBody:
      'Este enlace no es válido. Abre el enlace desde tu conversación de WhatsApp.',
    errorBody:
      'Algo ha fallado al cargar esta página. Inténtalo de nuevo en un momento.',
    fromAssistantNamed: 'De {{name}}, tu secretaria',
    fromAssistant: 'De tu secretaria',
    titleLead: 'Vamos a',
    titleAccent: 'empezar',
    coverCopy:
      'Seis cosas que me encargan cada semana — ejemplos reales, de usuarios reales. Elige una y del resto me ocupo yo.',
    swipeUp: 'Desliza hacia arriba',
    picked: 'Elegida — te escribo pronto',
    swipeNext: 'Desliza para ver la siguiente',
    thatsTheLot: 'Eso es todo — elige una ✦',
  },
  tour: {
    carouselAria: 'Novedades de Dream',
    whatsNew: 'Novedades',
    ofCount: '{{n}} de {{total}}',
    previous: 'Anterior',
    startExploring: 'Empezar a explorar',
    showMeAfter: 'Enséñamelo después',
    addedAfterList: 'Genial, te lo contaré',
    addedForWhatsApp: 'Añadido — te lo cuento por WhatsApp',
    added: 'Añadido',
    notInterested: 'Esto no me interesa',
    okThanks: 'Vale, gracias',
    doneTitle: 'Nos vemos en WhatsApp',
    doneBody:
      'Retomaré en nuestro chat todo lo que te haya interesado. Ya puedes cerrar esta página.',
    openWhatsApp: 'Volver a WhatsApp',
    linkExpiredTitle: 'Este enlace ha caducado',
    somethingOffTitle: 'Algo no va bien',
    expiredBody:
      'Este enlace ya no está activo. Escribe a tu secretaria por WhatsApp y pregúntale por las novedades.',
    invalidBody:
      'Este enlace no es válido. Abre el enlace desde tu conversación de WhatsApp.',
    errorBody: 'Algo ha salido mal. Inténtalo de nuevo en un momento.',
    scenes: {
      summary: {
        name: 'Resumen',
        headline: 'Esto es lo nuevo',
        tail: 'por ahora.',
        line: 'Lo que esté marcado lo retomo contigo en WhatsApp.',
      },
      intro: {
        name: 'Introducción',
        headline: '{{name}} tiene',
        tail: 'nuevas habilidades.',
        line: 'Aquí tienes {{count}} novedades de {{name}} para que las pruebes.',
      },
      scheduling: {
        name: 'Agenda',
        headline: 'No vuelvas a perseguir',
        tail: 'una hora para reunirte.',
        line: 'Dime con quién necesitas verte y más o menos cuándo. Acuerdo una hora con esa persona y la pongo en tu calendario.',
        topic: 'concertar reuniones',
      },
      assistants: {
        name: 'De secretaria a secretaria',
        headline: 'Reuniones con compañeros,',
        tail: 'acordadas entre secretarias.',
        line: 'Si ellos también usan Dream, nuestras secretarias cuadran la hora entre sí. Solo se comparte la agenda, nada más de tu calendario.',
        topic: 'hablar con las secretarias de otras personas',
      },
      shop: {
        name: 'Compra semanal',
        headline: 'Tu compra de Ocado,',
        tail: 'planificada y en la cesta.',
        line: 'Conecta Ocado y cuéntame cómo pinta la semana. Planifico las comidas, lleno la cesta y lo confirmo contigo antes de hacer el pedido.',
        topic: 'tu compra semanal de Ocado',
      },
      email: {
        name: 'Correo en WhatsApp',
        headline: 'Responde al correo',
        tail: 'sin abrirlo.',
        line: 'Redacto respuestas con tu voz y te las enseño aquí. Toca Enviar, o abre el borrador para cambiarlo antes.',
        topic: 'responder al correo desde WhatsApp',
      },
      check_in: {
        name: 'Repaso de la tarde',
        headline: 'Un repaso breve',
        tail: 'a las 19:00.',
        line: 'Qué se ha hecho hoy, qué sigue pendiente y cómo pinta mañana, para que nada se te escape de un día para otro.',
        topic: 'el repaso de las 19:00',
      },
      organisations: {
        name: 'Organizaciones',
        headline: 'Lleva Dream',
        tail: 'a tu empresa.',
        line: 'Configura Dream para todo tu equipo. Añade secretarias para tu gente clave, todo facturado en una sola tarjeta, y yo les ayudo a arrancar.',
        topic: 'Dream para tu organización',
      },
    },
  },
  briefing: {
    linkExpiredTitle: 'Esta lista se ha cerrado',
    somethingOffTitle: 'Algo no va bien',
    expiredBody:
      'Esta Morning List es de un día anterior. Lo que siga pendiente volverá a aparecer — o escribe a tu secretaria por WhatsApp.',
    invalidBody:
      'Este enlace no es válido. Abre el enlace desde tu conversación de WhatsApp.',
    errorBody: 'Algo ha fallado. Inténtalo de nuevo en un momento.',
    brandAria: 'Dream',
    listAria: 'Tu briefing',
    navAria: 'Navegación del briefing',
    optionsAria: 'Acciones para esto',
    chooseAnother: 'Elegir otra acción',
    openDraft: 'Abrir borrador',
    copyDraft: 'Copiar borrador',
    copied: 'Copiado',
    openLinkedin: 'Abrir en LinkedIn',
    openWhatsapp: 'Abrir WhatsApp',
    draftOnMac: 'También en WhatsApp en tu Mac',
    notRelevant: 'No es relevante',
    notRelevantAria: 'Esto no es relevante',
    chosen: 'Elegido: {{label}}',
    next: 'Siguiente',
    seeList: 'Ver tu lista de tareas',
    previous: 'Elemento anterior',
    whyPrompt:
      'Ya has pasado cosas como «{{headline}}» antes. Una palabra sobre el motivo me ayuda a dejar de proponerlas.',
    whyPlaceholder: '¿Por qué no es relevante?',
    whySkip: 'Omitir',
    whySend: 'Enviar',
    whyThanks: 'Gracias — anotado.',
    todosAria: 'Tus tareas',
    today: 'Hoy',
    tomorrow: 'Mañana',
    weekAria: 'Elegir un día',
    nothingPlanned: 'Nada previsto.',
    clearDay: 'Día despejado.',
    clearDayName: 'Día despejado, {{name}}.',
    nothingDueToday: 'Nada pendiente para hoy.',
    getAhead: 'Adelántate',
    noDate: 'Sin fecha',
    doToday: 'Hacerlo hoy',
    doTodayAria: 'Hacer {{title}} hoy',
    spottedInEmail: 'Visto en tu correo',
    spottedCount_one: '{{count}} cosa que quizá quieras añadir',
    spottedCount_other: '{{count}} cosas que quizá quieras añadir',
    sinceDay: 'desde el {{day}}',
    dueToday: 'Para hoy',
    dueTomorrow: 'Para mañana',
    dueOn: 'Para el {{date}}',
    addToToday: 'Añadir a hoy',
    addToTomorrow: 'Añadir a mañana',
    addFor: 'Añadir para el {{date}}',
    addToCalendar: 'Añadir al calendario',
    addedToTomorrow: 'Añadido a mañana.',
    addedFor: 'Añadido para el {{date}}.',
    addedToCalendar: 'Añadido a tu calendario.',
    addedToCalendarAt: 'En tu calendario: {{date}}, {{time}}.',
    notNow: 'Ahora no',
    doneAria: 'Marcar {{title}} como hecho',
    actionsFor: 'Acciones para {{title}}',
    delegate: 'Delegar',
    findTime: 'Buscar hueco',
    assistantFallback: 'Dream',
    notePlaceholder: '¿Alguna indicación?',
    noteAria: 'Nota para {{name}} sobre {{title}}',
    delegateSend: 'Pasárselo a {{name}}',
    pickHint: 'Toca una tarea para pasársela o buscarle un hueco',
    pickedFor: 'Para: {{title}}',
    recordVoiceNote: 'Grabar una nota de voz',
    stopRecording: 'Detener la grabación',
    listening: 'Escuchando…',
    transcribing: 'Anotando…',
    delegationQueued: 'En cola para {{name}}',
    delegationWorking: '{{name}} está en ello',
    micUnavailable: 'El micrófono no está disponible aquí.',
    lookingForTime: 'Mirando tu día…',
    howAbout: '¿Qué tal a las {{time}}?',
    howAboutContext: '¿Qué tal a las {{time}}, {{context}}?',
    bookIt: 'Reservar',
    otherTimes: 'Otros momentos',
    partMorning: 'Mañana',
    partAfterLunch: 'Después de comer',
    partAfternoon: 'Tarde',
    partEndOfDay: 'Final del día',
    booked: 'Reservado a las {{time}} en tu calendario.',
    noCalendar:
      'No hay ningún calendario conectado, así que no hay dónde reservar.',
    noFreeTime: 'No queda tiempo libre hoy.',
    noFreeTimeInPart: 'No hay tiempo libre en esa parte del día.',
    calendarUnavailable: 'Tu calendario no está disponible ahora mismo.',
  },
  booking: {
    noKey: 'No se ha proporcionado una clave de reserva',
    invalidData: 'Se han recibido datos de reserva no válidos',
    loadFailed:
      'No se pudo cargar la información de la reserva. Puede que el enlace haya caducado o no sea válido.',
    loading: 'Cargando la información de tu reserva...',
    errorTitle: 'Error en el enlace de reserva',
    goHome: 'Ir a la página principal',
    noDataTitle: 'Sin datos de reserva',
    noDataBody: 'No se pudo cargar la información de la reserva.',
    title: 'Completa la reserva de tu vuelo',
    redirectBody: 'Vas a ser redirigido para completar la reserva de tu vuelo.',
    provider: 'Proveedor de reservas',
    providerFallback: 'Proveedor de reservas de vuelos',
    redirectingIn: 'Redirección automática en {{seconds}} segundos...',
    continueTo: 'Continuar a {{provider}}',
    bookingSiteFallback: 'la web de reservas',
    disclaimer:
      'Serás redirigido a la web del proveedor de reservas para completar tu compra. Este enlace es seguro y caducará a las 24 horas.',
  },
  artifact: {
    proofTeamSaw: 'Lo que vio nuestro equipo',
    proofScreenshotOf: 'Captura {{n}} de {{total}}',
    proofEmailHeading: 'Correo de confirmación',
    proofEmailReceived: 'Recibido {{when}}',
    proofPrivate: 'Solo quien tenga este enlace puede ver esta página.',
    loading: 'Cargando...',
    unableToLoad: 'No se puede cargar',
    noShareToken: 'No se ha proporcionado un token de compartición',
    loadFailed: 'No se pudo cargar el elemento',
    gettingLivePrices: 'Obteniendo precios en directo',
    linkExpired: 'Este enlace ha caducado. Pide uno nuevo.',
    linkInvalid: 'Este enlace no es válido o el elemento ya no existe.',
    genericError: 'Algo ha fallado. Inténtalo de nuevo más tarde.',
    sessionExpired:
      'Esta sesión caducó porque no habías iniciado sesión. Pide a Dream que vuelva a enviarte el enlace.',
    linkExpiredShort: 'Este enlace ha caducado.',
    alreadyResponded: 'Esto ya ha recibido una respuesta.',
    submitFailed: 'No se pudo enviar la respuesta. Inténtalo de nuevo.',
    responseSubmitted: 'Respuesta enviada',
    responseSubmittedBody:
      'Tu respuesta ha quedado registrada. Puedes cerrar esta página.',
    bookingNow: 'Reservando',
    bookingNowBody:
      'Un momento — estamos reservando esto para ti. Recibirás la confirmación en el chat; puedes cerrar esta página.',
    booked: 'Reservado',
    bookedBody:
      'Listo. La confirmación está en tu chat. Puedes cerrar esta página.',
    bookedReference: 'Referencia {{reference}}',
    notBooked: 'No reservado',
    notBookedBody:
      'No se ha cobrado nada. Dream ya lo sabe y lo verá contigo en el chat.',
    bookingUnknown: 'Comprobando la reserva',
    bookingUnknownBody:
      'La reserva no se pudo confirmar de inmediato. Dream lo está comprobando con el operador y te avisará en el chat; no tienes que hacer nada más.',
    paymentReceived: 'Pago recibido',
    paymentReceivedBody:
      'Estamos confirmando tu pago: tus créditos se añadirán en un momento. Puedes cerrar esta página.',
    topUpComplete: 'Recarga completada',
    topUpCreditsAdded:
      'Se han añadido {{credits}} créditos a tu cuenta. Puedes cerrar esta página.',
    topUpAlreadyDone:
      'Esta recarga ya se ha completado. Puedes cerrar esta página.',
    topUpMissingDetails:
      'A este enlace de recarga le faltan los detalles. Pide uno nuevo.',
    checkoutFailed: 'No se pudo iniciar el pago. Inténtalo de nuevo.',
    linkExpiredAskDream:
      'Este enlace ha caducado. Pide a Dream que envíe uno nuevo.',
    topUpAlreadyCompleted: 'Esta recarga ya se ha completado.',
    topUpFailed:
      'No se pudo procesar la recarga. No se ha hecho ningún cargo a tu tarjeta.',
    continueSecureCheckout: 'Continuar al pago seguro',
    cardSetupFailed:
      'No se pudo iniciar el registro de la tarjeta. Inténtalo de nuevo.',
    cardAdded: 'Tarjeta añadida',
    cardAddedBody:
      'Tu tarjeta está guardada. Tu secretaria podrá recargarla cuando apruebes una compra. Puedes cerrar esta página.',
    subscriptionActive: 'Suscripción activa',
    subscriptionActiveBody:
      'Tu plan está configurado y tus créditos se han añadido. Puedes cerrar esta página.',
    subscriptionPendingBody:
      'Estamos confirmando tu suscripción: tus créditos se añadirán en un momento. Puedes cerrar esta página.',
    selectPlan: 'Elige un plan',
    popular: 'POPULAR',
    yourPlan: 'Tu plan',
    loadingShort: 'Cargando...',
    choosePlan: 'Elegir {{name}}',
    addCardOnly: 'O simplemente añade una tarjeta sin plan',
    noContent: 'No hay contenido disponible.',
    alreadyHandled: 'Ya gestionado',
    alreadyHandledTitled:
      '«{{title}}» ya ha recibido una respuesta, así que no hace falta hacer nada aquí. Puedes cerrar esta página.',
    alreadyHandledUntitled:
      'Esta solicitud ya ha recibido una respuesta, así que no hace falta hacer nada aquí. Puedes cerrar esta página.',
    secureLoginCancelled: 'Inicio de sesión cancelado',
    secureLoginCancelledLead: 'Inicio de sesión',
    secureLoginCancelledAccent: 'cancelado',
    secureLoginDone: 'Sesión iniciada',
    secureLoginDoneAccent: 'de forma segura',
    secureLoginDoneBody:
      'Dream puede continuar con tu inicio de sesión. Puedes cerrar esta página.',
    secureCardSaved: 'Tarjeta guardada',
    secureCardSavedAccent: 'de forma segura',
    secureCardSavedBody:
      'Tu tarjeta se guarda de forma segura y nunca se comparte con tu secretaria. Puedes cerrar esta página.',
    secureLoginCancelledBody:
      'No se ha guardado ningún dato. Puedes cerrar esta página y volver a pedírselo a tu secretaria cuando quieras.',
  },
  wizard: {
    stepLabelPrivacy: 'Tu privacidad',
    mobileStepPrivacy: 'Privacidad',
    getStarted: 'Empezar',
    close: 'Cerrar',
    privacyStep: {
      title: 'Delega lo aburrido, no tus datos',
      lede: 'Una secretaria de primer nivel que se ocupa de tu día a día y protege tus datos.',
      point1: 'No usamos tus datos para entrenar nuestros modelos',
      point2: 'Nunca vendemos tus datos a nadie',
      point3:
        'Cuando conectas una app, siempre puedes ver cómo la usa tu secretaria',
      point4:
        'Borrado es borrado. Tus apps, tu cuenta: si tiene que desaparecer, desaparece',
      point5: 'Dream no guarda ningún correo que recibas',
      learnMore: 'Quiero saber más',
      analyticsTitle: 'Ayuda a mejorar tu secretaria',
      analyticsBody:
        'Ayúdanos a revisar cómo está funcionando tu secretaria. Los resultados son anónimos, nadie lee tus conversaciones.',
      modalTitle: 'Tu privacidad, explicada de forma sencilla',
      rights: {
        memoryTitle: 'Derecho a gestionar la memoria de tu secretaria',
        memoryBody:
          'Puedes ver qué información importante recuerda tu secretaria sobre ti. Puedes corregirla o pedirle que la borre.',
        conversationTitle: 'Derecho a una conversación privada',
        conversationBody:
          'Lo que le cuentas a tu secretaria es privado. Solo compartiremos una conversación si la ley nos obliga. Los técnicos de Dream solo pueden ver una conversación si has informado de un fallo, y te avisaremos.',
        dataUseTitle: 'Derecho a saber cómo usamos tus datos',
        dataUseBody: 'No vendemos tus datos personales.',
        knowTitle: 'Derecho a saber qué sabe Dream de ti',
        knowBody:
          'Puedes preguntarnos qué datos tenemos sobre ti y recibir una copia.',
        correctTitle: 'Derecho a corregir lo que Dream tiene mal',
        correctBody:
          'Si algún dato que tenemos sobre ti es incorrecto, puedes pedirnos que lo corrijamos.',
        deleteTitle: 'Derecho a borrar tus datos',
        deleteBody:
          'Puedes pedirnos que borremos tus datos. Puede que tengamos que conservar algunos si la ley lo exige.',
        portabilityTitle: 'Derecho a llevarte tus datos',
        portabilityBody:
          'Puedes pedirnos una copia de tus datos en un formato que puedas usar en otro sitio.',
        limitTitle: 'Derecho a limitar el uso de tus datos',
        limitBody:
          'Puedes pedirnos que dejemos de usar tus datos o que los usemos menos, siempre que la app pueda seguir funcionando.',
        accessTitle: 'Derecho a saber a qué accede tu secretaria',
        accessBody:
          'Puedes ver a qué cuentas y servicios tiene acceso tu secretaria. Puedes quitarle ese acceso cuando quieras.',
        providersTitle: 'Derecho a saber quién más necesita tus datos',
        providersBody:
          'Dream trabaja con algunos proveedores de tecnología. Se comprueba que cumplen el RGPD.',
        securityTitle: 'Derecho a una seguridad razonable',
        securityBody:
          'Protegemos tus datos y evitamos que nadie acceda a ellos sin permiso.',
      },
    },
    stepLabel1: 'Conecta tus cuentas',
    stepLabel2: 'Resumen diario',
    stepLabel3: 'Integraciones',
    stepLabel4: 'Tu secretaria',
    stepLabel5: 'Primeras tareas',
    mobileStep1: 'Cuentas',
    mobileStep2: 'Resumen',
    mobileStep3: 'Integraciones',
    mobileStep4: 'Secretaria',
    mobileStep5: 'Primeras tareas',
    briefingSub1: 'Qué es',
    briefingSub2: 'Cuándo llega',
    briefingSub3: 'Otras rutinas',
    assistantSub1: 'Nombre',
    assistantSub2: 'Correo',
    assistantSub3: 'Tarjeta',
    assistantSub4: 'El equipo',
    taskSub1: 'Ya hecho',
    taskSub2: 'Referidos',
    taskSub3: 'Tu primera tarea',
    continue: 'Continuar',
    letsGetStarted: 'Empecemos',
    back: 'Atrás',
    stepOf: '{{label}} · {{step}} de {{total}}',
    eyebrow: 'Paso {{step}} de {{total}} · {{label}}',
    oneMoment: 'Un momento…',
    loadingSetup: 'Cargando tu configuración…',
    linkErrorTitle: 'Vaya, ese enlace no funcionó',
    missingToken:
      'A este enlace le falta su token. Pide uno nuevo a tu secretaria.',
    loadFailed: 'Algo salió mal al cargar tu configuración.',
    genericError: 'Algo salió mal. Inténtalo de nuevo.',
    allSetTitle: 'Todo listo',
    allSetBody:
      'Vuelve a tu chat de WhatsApp con {{name}} — te está esperando.',
    openWhatsApp: 'Abrir WhatsApp',
    privacy: 'Privacidad',
    terms: 'Términos',
    openingWhatsAppToast: 'Abriendo WhatsApp — «{{task}}» con {{name}}.',
    oauthMissingScopes:
      'Tu cuenta está conectada. No se concedió acceso a {{scopes}}, así que tu secretaria no podrá ayudarte con {{area}} en esta cuenta. Puedes conceder el acceso en cualquier momento reconectando la cuenta.',
    oauthMissingAreaSingle: 'esa área',
    oauthMissingAreaMulti: 'esas áreas',
    oauthNoMailboxTitle: 'Conectada, pero esta cuenta no tiene buzón de Gmail',
    oauthNoMailbox:
      'Google indica que Gmail no está activado en esta cuenta (su Workspace ya no incluye Gmail o es un inicio de sesión de Google con una dirección que no es de Gmail). Tu secretaria podrá usar su calendario y contactos, pero no leer, buscar ni redactar correos desde ella. Si tu correo está en otro sitio, conecta también esa cuenta.',
    listAnd: 'y',
    oauthAlreadyLinkedOther:
      'Esa cuenta de correo ya está vinculada a otra cuenta, así que no se pudo añadir aquí. Conecta otra distinta, o contáctanos si crees que es un error.',
    oauthExpired:
      'Este enlace de configuración ha caducado. Pide uno nuevo a tu secretaria en WhatsApp.',
    oauthInvalidToken:
      'Este enlace de configuración ya no es válido. Pide uno nuevo a tu secretaria en WhatsApp.',
    oauthError: 'Algo salió mal al conectar esa cuenta. Inténtalo de nuevo.',
    halfModalTitle: 'Dream solo puede ver la mitad de tu semana',
    halfModalWork:
      'Sin tu calendario de trabajo, ofrecerá horarios en los que en realidad no estás libre y se perderá lo que más importa.',
    halfModalPersonal:
      'Sin tu calendario personal, reservará sobre tus tardes y fines de semana como si estuvieran libres.',
    connectWork: 'Conectar trabajo',
    connectPersonal: 'Conectar personal',
    carryOnAnyway: 'Continuar de todos modos',
    noAccount: {
      title: '¿Continuar sin una cuenta?',
      needs:
        '{{name}} necesita ver tu calendario y tu correo para hacer su mejor trabajo.',
      impact:
        'No podrá comprobar tu disponibilidad, y eso podría causar choques en tu agenda.',
      changeLater:
        'Si estás seguro, elige «continuar» abajo. Puedes cambiar de opinión más adelante.',
      understandContinue: 'Entendido, continuar',
      goBackConnect: 'Volver y conectar',
    },
    previewCap: 'Lo que llega a las',
    previewMorning:
      'Buenos días{{name}} — aquí tienes tu día. Tres reuniones, dos respuestas pendientes.',
    previewFullBriefing: 'Resumen completo de cada reunión',
    previewEveningRoundUp: 'Repaso vespertino de temas pendientes',
    previewOwedReplies: 'Respuestas que debes, y que te deben',
    connect: {
      title: 'Conecta tus cuentas',
      ledeWide:
        'Conecta tu correo y tu calendario para que {{name}} esté al tanto de tus tareas y vigile los conflictos de agenda.',
      ledeNarrow:
        'Conecta tu correo y tu calendario para que {{name}} vea toda tu semana.',
      ledeExtra:
        'Añade tu cuenta personal y la de trabajo para que vea toda tu semana.',
      personal: 'Personal',
      personalSub: 'Tu propio correo y agenda.',
      work: 'Trabajo',
      workSub: 'Donde están la mayoría de tus reuniones.',
      connected: 'Conectada',
      notConnected: 'No conectada',
      connectedAccount: 'Cuenta conectada',
      disconnectAria: 'Desconectar {{account}}',
      thisAccount: 'esta cuenta',
      addAnother: 'Añadir otra',
      opening: 'Abriendo…',
      openConnectError: 'No se pudo abrir la página de conexión.',
      disconnectError: 'No se pudo desconectar la cuenta.',
      adminNoteTitle: '¿No pudiste conectar tu cuenta de trabajo?',
      adminNoteBody:
        'Si te devolvió directamente sin una pantalla de consentimiento, puede que el administrador de tu espacio de trabajo tenga que aprobar Dream primero — aquí tienes una guía para enviarle.',
      adminGuideShareTitle:
        'Por qué Dream necesita acceso a tu cuenta de Google',
      sendAdminGuide: 'Envía la guía a tu administrador',
      guideLinkCopied: 'Enlace copiado — pégaselo a tu administrador',
      viewGuide: 'Ver la guía',
      dismiss: 'Descartar',
      connectionDidntFinish: 'Esa conexión no se completó',
      neverSend: 'Nunca enviará un correo desde tu cuenta.',
      disclaimer: 'Admitimos cuentas de Gmail, Google Workspace y Outlook.',
      noAccountHint: '¿Prefieres no conectar ninguna?',
      carryOnWithout: 'Continuar sin una cuenta de correo',
      chooseTitle: 'Conecta una cuenta de correo',
      chooseLede:
        'Gmail u Outlook. Sabré por la dirección si es de trabajo o personal, y puedes cambiarlo.',
      gmail: 'Gmail',
      outlook: 'Outlook',
      workNeededNote:
        '{{org}} necesita tu correo del trabajo, así que conecta ese.',
      kindAria: 'Trabajo o personal',
      changeKindError:
        'No se pudo cambiar el tipo de cuenta. Inténtalo de nuevo.',
      kindLabel: '¿Qué tipo de cuenta es?',
      professional: 'Profesional',
      professionalSub: 'Tu correo y calendario del trabajo.',
      neededFor: 'Necesaria para {{org}}',
      providerLabel: '¿Con qué proveedor es?',
      google: 'Google',
      microsoft: 'Microsoft',
      other: 'Otro',
      otherNoteWork:
        '{{org}} necesita una cuenta de trabajo de Google o Microsoft. Si tu correo del trabajo es de otro proveedor, pregunta a tu equipo de IT.',
      otherNote:
        'Por ahora {{name}} funciona con cuentas de Google y Microsoft. Puedes continuar sin una y conectarla más tarde.',
    },
    briefing: {
      whatTitle: 'Despierta con los deberes hechos',
      whatLedeWide:
        'Cada mañana, un solo mensaje con todo lo que de otro modo descubrirías demasiado tarde.',
      whatLedeNarrow: 'Un mensaje cada mañana, por WhatsApp.',
      morningLede: 'Buenos días{{name}} — aquí tienes tu día.',
      line1: 'Vuelo a Ámsterdam, 11:05 — tarjeta de embarque adjunta',
      line2: 'Tres reuniones, todas con resumen y fotos',
      line3: 'Dos respuestas pendientes, borradores listos',
      line4: 'El cumpleaños de Angie es el jueves',
      whatFoot: 'Llega por WhatsApp, cada mañana.',
      whenTitle: '¿Cuándo debería llegar?',
      whenLedeWide:
        'Elige una hora que te convenga — puedes cambiarla cuando quieras.',
      whenLedeNarrow: 'Elige una hora — puedes cambiarla más tarde.',
      arrivesAt: 'Llega a las',
      onWhatsApp: 'Por WhatsApp',
      earlier15: '15 minutos antes',
      later15: '15 minutos después',
      deliveryTimeAria: 'Hora de entrega del resumen',
      includeInBriefing: 'Incluir en el resumen',
      fullMeetingBriefing: 'Resumen completo de reuniones',
      alwaysOn: 'Siempre activo',
      fullMeetingSub:
        'Fotos, cómo os presentaron y cómo pronunciar el nombre de cada persona.',
      routinesTitle: 'Más cosas que tu secretaria puede gestionar',
      routinesLede:
        'Todas están activadas al principio — desactiva lo que no quieras.',
      eveningTitle: 'Repaso vespertino de temas pendientes',
      eveningSub:
        'Un mensaje breve al final del día: lo que se quedó en el tintero, lo que dijiste que harías y lo que te espera mañana.',
      owedTitle: 'Seguimiento de respuestas pendientes',
      owedSub:
        'Lleva la cuenta de quién te espera y a quién esperas tú, y te avisa antes de que sea embarazoso.',
      labellingTitle: 'Ordenar y etiquetar tu bandeja de entrada',
      labellingSub:
        'Etiqueta lo que llega — recibos, boletines, cosas que te necesitan — y aparta el ruido. ¿Ya tienes tu bandeja en orden? Déjalo desactivado.',
    },
    integrations: {
      title: 'Conecta Dream con todo lo demás',
      ledeWide:
        '{{name}} puede trabajar dentro de las herramientas que ya usas, leyendo lo que hay y haciendo las partes que harías a mano.',
      ledeNarrow: '{{name}} trabaja dentro de las herramientas que ya usas.',
      ledeExtra: 'Conecta lo que quieras ahora, o vuelve a hacerlo más tarde.',
      alreadyConnected: 'Ya conectado',
      whatsappRowName: 'WhatsApp',
      whatsappRowMeta: 'Donde habláis tú y {{name}}',
      spottedInEmail: 'Detectado en tu correo',
      everythingElse: 'Todo lo demás',
      addMore: 'Añadir más',
      showFewer: 'Mostrar menos',
      showAll: 'Mostrar los {{count}}',
      connected: 'Conectado',
      connect: 'Conectar',
      comingSoon: 'Próximamente',
      cancel: 'Cancelar',
      close: 'Cerrar',
      verifying: 'Verificando…',
      personal: 'Personal',
      work: 'Trabajo',
      connectedAccount: 'Cuenta conectada',
      connectApp: 'Conectar {{name}}',
      apiKeyBody: '{{hint}} y {{name}} la verificará antes de guardarla.',
      apiKeyDefaultHint: 'Pega tu clave API',
      apiKeyPlaceholder: 'Clave API de {{name}}',
      connectError: 'No se pudo conectar. Inténtalo de nuevo.',
      apps: {
        slack: {
          sub: 'Mensajes y canales',
          spottedSub:
            'Vigila los canales que importan, publica actualizaciones en tu nombre y te pone al día de lo que te perdiste.',
        },
        hubspot: {
          sub: 'Contactos y negocios',
          spottedSub:
            'Registra llamadas y notas, mantiene al día negocios y contactos, y persigue los siguientes pasos por ti.',
        },
        attio: {
          sub: 'Registros de CRM',
          spottedSub:
            'Mantiene al día los registros y los contactos nuevos tras cada llamada y correo, sin que hagas el trabajo administrativo.',
        },
        linear: {
          sub: 'Incidencias y proyectos',
          spottedSub:
            'Crea, actualiza y da seguimiento a incidencias para que tus proyectos sigan avanzando mientras estás en otra cosa.',
        },
        notion: {
          sub: 'Páginas, listas y bases de datos',
          spottedSub:
            'Lee tus listas de tareas compartidas, añade y marca elementos, y crea o actualiza páginas y bases de datos por ti.',
        },
        asana: {
          sub: 'Tareas y proyectos',
          spottedSub:
            'Crea y actualiza tareas a partir de tus conversaciones y persigue lo que esté bloqueando un proyecto.',
        },
        todoist: {
          sub: 'Tu lista de tareas',
          spottedSub:
            'Añade tareas directamente desde el correo y WhatsApp, y las marca como hechas cuando se completan.',
        },
        granola: {
          sub: 'Notas de reuniones',
          spottedSub:
            'Convierte automáticamente tus notas de reunión en acciones y seguimientos después de cada llamada.',
        },
        xero: {
          sub: 'Facturas y gastos',
          spottedSub:
            'Reclama facturas impagadas, archiva recibos y vigila los gastos sin que tengas que abrirlo.',
        },
        lusha: {
          sub: 'Enriquecimiento de contactos',
          spottedSub:
            'Encuentra los datos de contacto de las personas con las que quieres hablar, justo cuando los necesitas.',
          keyHint: 'Pega tu clave de API de Lusha',
        },
        devin: {
          sub: 'Tareas de ingeniería',
          spottedSub:
            'Delega trabajos de ingeniería, los sigue hasta terminarlos y te avisa cuando te necesitan.',
          keyHint: 'Pega tu clave de API de Devin',
        },
      },
    },
    assistant: {
      nameTitle: 'Conoce a tu secretaria',
      nameLedeWide:
        'Se presentará con este nombre. Cámbialo si prefieres llamarlo de otra manera.',
      nameLedeNarrow: 'Cámbialo si prefieres llamarlo de otra manera.',
      nameLabel: 'Nombre de tu secretaria',
      nameRequired: 'Ponle un nombre a tu secretaria.',
      emailTitle: '{{name}} tiene su propia dirección de correo',
      emailLede:
        'Puede hablar con el mundo en tu nombre — y solo te responderá a ti.',
      sigQuote:
        '…He puesto tres opciones para el jueves. Dime cuál te viene bien y lo confirmo.',
      sigRole: 'Secretaria',
      sigRoleTo: 'Secretaria de {{name}}',
      whenEmail: '¿Cuándo puede enviar correos?',
      expressPermission: 'Solo cuando dé mi permiso expreso',
      cardTitle: 'Y su propia tarjeta',
      cardLede:
        'Para reservar y comprar en tu nombre. Nunca gasta sin tu visto bueno.',
      cardKind: 'Virtual · Un solo uso',
      cardholder: 'Titular',
      expires: 'Caduca',
      whenSpend: '¿Cuándo puede gastar?',
      teamTitle: 'Hay personas detrás de {{name}}',
      teamLedeWide:
        'Algunas cosas no las puede hacer el software. Cuando eso ocurre, una persona formada de nuestro equipo se encarga — y {{name}} sigue siendo quien habla contigo.',
      teamLedeNarrow:
        'Cuando el software no puede, una persona real se encarga. {{name}} sigue siendo quien habla contigo.',
      whatTheyDo: 'Qué harán',
      teamItem1:
        'Llamar a un restaurante, una clínica o un local sin sistema de reservas',
      teamItem2: 'Navegar por una web que se resiste a la automatización',
      teamItem3: 'Insistir en algo que necesita que un humano siga preguntando',
      playSample: 'Reproducir llamada de ejemplo',
      pauseSample: 'Pausar llamada de ejemplo',
      hearCallIn: 'Escucha la llamada en',
      callLanguage: {
        en: 'Inglés',
        de: 'Alemán',
        fr: 'Francés',
        it: 'Italiano',
        es: 'Español',
      },
      audioTitle: 'Escucha una llamada real, reservando mesa',
    },
    alreadyDone: {
      putToWorkTitle: 'Pon a {{name}} a trabajar',
      putToWorkLede:
        'Primer trabajo: redactar respuestas y seguimientos para lo que espera en tu bandeja de entrada.',
      firstDrafts: 'Tus primeros borradores',
      firstDraftsSub:
        'Listos en unos minutos. {{name}} nunca envía — lo haces tú.',
      draftCta: 'Redactar mis primeras respuestas',
      hitASnag: '{{name}} se topó con un problema',
      snagLede:
        'No pude terminar tus primeros borradores — tranquilo, no ha pasado nada.',
      snagLine1: 'Sigo redactando a medida que llega correo nuevo',
      snagLine2: 'Nada se envía sin ti',
      tryingAgain: 'Intentándolo de nuevo…',
      tryAgain: 'Intentar de nuevo',
      alreadyDoneTitle: 'Ya hecho',
      emptyLede: 'Todo al día — nada necesitaba respuesta ahora mismo.',
      emptyLine1: 'Redacto a medida que llega correo nuevo',
      emptyLine2: 'Todo espera en tu carpeta de borradores',
      readyLede: 'Hecho — tus borradores están listos.',
      readyLine1: 'Esperando en tu carpeta de borradores',
      readyLine2: 'Edítalos tú mismo, o pídeme cambios',
      onItTitle: '{{name}} está en ello',
      now: 'ahora',
      working: 'Trabajando',
      workingLede:
        'Estoy revisando tu bandeja de entrada — tus primeros borradores tardan unos minutos.',
      workingLine1:
        'Esperarán en tu carpeta de borradores — nada se envía sin ti',
      workingLine2: 'Te avisaré por WhatsApp en cuanto estén listos',
      workingFoot: 'No hace falta esperar aquí — puedes continuar.',
    },
    referrals: {
      title: 'Invita a tus amigos, delega más',
      lede1: 'Empieza con {{amount}} de créditos al mes, gratis.',
      lede2: 'Invita a un amigo y os lleváis {{amount}} de créditos cada uno.',
      lede1V3:
        'Tu primer mes de Dream es gratis: uso ilimitado, por nuestra cuenta.',
      lede2V3: 'Invita a un amigo y ambos recibiréis uso extra en Dream.',
      invitesNote:
        'Tienes {{count}} invitaciones este mes, elige a alguien que de verdad necesite una secretaria.',
      yourInviteLink: 'Tu enlace de invitación',
      copied: 'Copiado',
      copyLink: 'Copiar enlace',
      copyError: 'No se pudo copiar tu enlace — selecciónalo y cópialo.',
    },
    tasks: {
      loaderTitle: 'Conociéndote',
      loaderLede:
        'Dame un momento con tu correo y tu calendario. Esto es lo que he captado hasta ahora.',
      spline1: 'Leyendo el ritmo de tu semana',
      spline2: 'Entendiendo tus patrones de viaje',
      spline3: 'Averiguando cuándo prefieres las reuniones',
      spline4: 'Detectando a las personas con las que más hablas',
      spline5: 'Aprendiendo qué correos te importan de verdad',
      spline6: 'Observando tus reservas y sitios habituales',
      spline7: 'Mapeando tus mañanas y tus noches',
      spline8: 'Detectando suscripciones y renovaciones',
      title: '¿Qué debería hacer {{name}} primero?',
      lede: 'Elige una — los detalles los cierras en el chat.',
      pickOne: 'Elige una para empezar',
      chooseAria: 'Elegir una primera tarea',
      somethingElse: 'Otra cosa',
      somethingElseTagline: 'Puedes pedir cualquier cosa',
      bookRestaurant: 'Reservar un restaurante',
      bookHaircut: 'Reservar una cita de peluquería',
      findFlights: 'Buscar vuelos',
      yourFirstTask: 'tu primera tarea',
      validation: 'Elige una para empezar.',
      handoff: 'Abre tu chat de WhatsApp con {{name}}.',
    },
  },
  // Vista pública de invitado de una lista de tareas compartida (ver en.ts).
  login: {
    title: 'Inicia sesión en Dream',
    lede: 'Introduce el número de teléfono que usas con Dream y te enviaremos un código de un solo uso por SMS.',
    phoneLabel: 'Número de teléfono',
    countryLabel: 'Prefijo del país',
    countrySearchPlaceholder: 'Buscar países',
    countryNoResults: 'Ningún país coincide',
    sendCode: 'Enviarme un código',
    or: 'o',
    continueWithGoogle: 'Continuar con Google',
    continueWithMicrosoft: 'Continuar con Microsoft',
    newHere:
      '¿Nuevo en Dream? Empieza primero una conversación con tu secretaria en WhatsApp.',
    errors: {
      empty: 'Introduce tu número de teléfono.',
      malformed: 'Eso no parece un número de teléfono. Usa solo dígitos.',
      tooShort:
        'Ese número es demasiado corto para {{selectedCountry}} ({{selectedCode}}).',
      tooLong:
        'Ese número es demasiado largo para {{selectedCountry}} ({{selectedCode}}).',
      countryMismatch:
        'Ese número empieza por {{typedCode}} ({{typedCountry}}), pero está seleccionado {{selectedCountry}} ({{selectedCode}}). Elige {{typedCountry}} en el desplegable o quita el prefijo.',
      invalidForCountry:
        'Ese no es un número válido de {{selectedCountry}}. Compruébalo e inténtalo de nuevo.',
    },
  },
  todoGuest: {
    pageTitle: 'Lista de tareas compartida · Dream',
    banner:
      '<strong>{{inviter}}</strong> te ha invitado a editar la lista <strong>{{list}}</strong> con Dream',
    members_one: '{{count}} miembro',
    members_other: '{{count}} miembros',
    you: '{{name}} (tú)',
    empty: 'Todavía no hay nada en esta lista.',
    completedByYou: 'Completadas por ti',
    task: {
      from: 'de {{name}}',
      fromGuest: 'de {{name}} (invitado)',
      editedBy: 'editada por {{name}}',
      assignedToYou: 'Tú',
      unassigned: 'Sin asignar',
      complete: 'Marcar como hecha',
      reopen: 'Marcar como no hecha',
      notYours:
        'Solo la persona a la que está asignada esta tarea puede marcarla',
    },
    newTask: {
      button: 'Nueva',
      title: 'Nueva tarea',
      descriptionLabel: 'Tarea',
      descriptionPlaceholder: 'Describe tu tarea',
      dueDateLabel: 'Añadir fecha límite',
      assignLabel: 'Asignar',
      unassigned: 'Sin asignar',
      priorityLabel: 'Añadir prioridad',
      noPriority: 'Sin prioridad',
      priority: {
        high: 'Prioridad alta',
        medium: 'Prioridad media',
        low: 'Prioridad baja',
      },
      submit: 'Añadir tarea',
      submitting: 'Añadiendo…',
      error: 'No se pudo añadir la tarea. Inténtalo de nuevo.',
    },
    errors: {
      updateFailed: 'No se pudo actualizar la tarea. Inténtalo de nuevo.',
    },
    verify: {
      titleWhatsApp: 'Busca tu código en WhatsApp',
      titleEmail: 'Busca tu código en tu correo',
      bodyWhatsApp:
        'Para abrir la lista <strong>{{list}}</strong> de <strong>{{inviter}}</strong>, introduce el código de 6 dígitos que acabamos de enviar al <strong>{{destination}}</strong> por WhatsApp.',
      bodyEmail:
        'Para abrir la lista <strong>{{list}}</strong> de <strong>{{inviter}}</strong>, introduce el código de 6 dígitos que acabamos de enviar a <strong>{{destination}}</strong>.',
      codeLabel: 'Código de verificación',
      submit: 'Abrir la lista',
      checking: 'Comprobando…',
      sending: 'Enviando tu código…',
      resendIn_one: 'Reenviar el código en {{count}} segundo',
      resendIn_other: 'Reenviar el código en {{count}} segundos',
      resend: 'Reenviar el código',
      sendCode: 'Enviarme un código',
      errors: {
        invalid: 'Ese código no es correcto. Inténtalo de nuevo.',
        invalidWithAttempts_one:
          'Ese código no es correcto. Te queda {{count}} intento.',
        invalidWithAttempts_other:
          'Ese código no es correcto. Te quedan {{count}} intentos.',
        expired: 'Ese código ha caducado. Solicita uno nuevo.',
        tooManyAttempts:
          'Demasiados intentos incorrectos. Solicita un código nuevo.',
        sendFailed:
          'No hemos podido enviar tu código ahora mismo. Inténtalo de nuevo.',
        generic: 'Algo ha salido mal. Inténtalo de nuevo.',
      },
    },
    invalid: {
      title: 'Este enlace ha caducado. Tendrán que invitarte de nuevo.',
      body: 'Consigue tu propia secretaria para acceder a listas y mucho más.',
      cta: 'Regístrate ahora por WhatsApp',
    },
    nudge: {
      title: 'Haz aún más con tu propia Secretaria de IA',
      body: 'Consigue una secretaria de primer nivel, respaldada por secretarias reales formadas, lista para ocuparse de tu día a día.',
      getYourOwnPa: 'Conseguir mi propia secretaria',
      phonePrompt:
        'Empieza a chatear con tu secretaria en WhatsApp — introduce tu número de teléfono',
      phonePlaceholder: 'Tu número de teléfono',
      phoneSubmit: 'Continuar en WhatsApp',
      phoneInvalid:
        'Introduce un número de teléfono válido con el prefijo del país.',
      outcome: {
        sent: 'Listo — mira WhatsApp, tu nueva secretaria acaba de escribirte.',
        already_on_dream:
          'Ese número ya tiene una cuenta de Dream. Abre WhatsApp para seguir hablando con tu secretaria.',
        already_invited:
          'Ya has empezado a registrarte — abre WhatsApp para continuar donde lo dejaste.',
      },
      error: 'Algo ha fallado. Inténtalo de nuevo.',
      later: 'Quizás más tarde',
    },
  },
  expenseReview: {
    headingSingle: 'Tu solicitud de reembolso',
    headingMulti: 'Tus solicitudes de reembolso',
    subSingle:
      'Aún no se ha enviado. Elige «Enviar» o pídeselo a tu secretaria cuando estés listo.',
    subMulti:
      'Aún no se han enviado. Elige «Enviar» o pídeselo a tu secretaria cuando estés listo.',
    alreadySubmittedSingle: 'Este gasto ya se ha enviado.',
    alreadySubmittedMulti: 'Estos gastos ya se han enviado.',
    empty: 'No hay gastos en esta revisión.',
    submit: 'Enviar',
    submitting: 'Enviando…',
    submitAll: 'Enviar los {{count}}',
    submitSome: 'Enviar {{selected}} de {{total}}',
    close: 'Cerrar',
    notNow: 'Ahora no',
    error: 'No se pudo conectar con Dream. Inténtalo de nuevo.',
    include: 'Incluir {{vendor}}',
    thisExpense: 'este gasto',
    unknownVendor: 'Proveedor desconocido',
    amountMissing: 'Falta el importe',
    duplicate: 'Parece un duplicado de un gasto ya registrado (ref. {{ref}}).',
    rows: {
      settledOnCard: '{{amount}} en la tarjeta',
      inYourAccounts: 'Abrir en tu contabilidad',
    },
    paymentMethod: {
      company_card: 'Tarjeta de empresa',
      personal_card: 'Tarjeta personal (reembolso)',
    },
    status: {
      draft: 'Borrador',
      awaiting_info: 'Faltan datos',
      awaiting_confirmation: 'Listo para contabilizar',
      approved: 'Aprobado',
      submitted: 'Contabilizado',
      failed: 'Error al contabilizar',
      discarded: 'Descartado',
    },
    receipts: {
      none: 'Sin recibo adjunto',
      fallbackName: 'Recibo {{n}}',
      openInDream: 'Abre Dream para ver el archivo',
    },
  },
};

export default es;
